export const ICON_DRAWERS = {
  TypeScript(ctx, s) {
    ctx.font = `bold ${s}px Arial, sans-serif`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText('TS', 0, 0)
  },

  'C#'(ctx, s) {
    ctx.font = `bold ${s}px Arial, sans-serif`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText('C#', 0, 0)
  },

  Java(ctx, s) {
    const lw = Math.max(1.5, s * 0.11)
    ctx.lineWidth = lw
    ctx.beginPath()
    ctx.moveTo(-s * 0.38, -s * 0.35)
    ctx.lineTo(-s * 0.44, s * 0.35)
    ctx.lineTo(s * 0.44, s * 0.35)
    ctx.lineTo(s * 0.38, -s * 0.35)
    ctx.stroke()
    ctx.beginPath()
    ctx.arc(s * 0.62, 0, s * 0.22, -Math.PI * 0.5, Math.PI * 0.5)
    ctx.stroke()
    ctx.lineWidth = lw * 0.65
    ctx.beginPath()
    ctx.moveTo(0, -s * 0.35)
    ctx.bezierCurveTo(s * 0.15, -s * 0.6, -s * 0.15, -s * 0.72, s * 0.05, -s * 0.92)
    ctx.stroke()
  },

  AI(ctx, s) {
    const r = Math.max(2, s * 0.1)
    const N = [
      [-s * 0.5, -s * 0.28], [-s * 0.5, s * 0.28],
      [0, -s * 0.44], [0, 0], [0, s * 0.44],
      [s * 0.5, 0],
    ]
    ctx.lineWidth = Math.max(1, s * 0.055)
    const edges = [[0,2],[0,3],[0,4],[1,2],[1,3],[1,4],[2,5],[3,5],[4,5]]
    edges.forEach(([a, b]) => {
      ctx.beginPath()
      ctx.moveTo(N[a][0], N[a][1])
      ctx.lineTo(N[b][0], N[b][1])
      ctx.stroke()
    })
    N.forEach(([x, y]) => {
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill()
    })
  },

  Bike(ctx, s) {
    ctx.lineWidth = Math.max(1.5, s * 0.1)
    const wr = s * 0.32
    const lx = -s * 0.4, rx = s * 0.4, axY = s * 0.12
    ctx.beginPath(); ctx.arc(lx, axY, wr, 0, Math.PI * 2); ctx.stroke()
    ctx.beginPath(); ctx.arc(rx, axY, wr, 0, Math.PI * 2); ctx.stroke()
    const sadX = -s * 0.05, sadY = -s * 0.18
    ctx.beginPath()
    ctx.moveTo(lx, axY);  ctx.lineTo(sadX, sadY)
    ctx.lineTo(rx, axY);  ctx.moveTo(sadX, sadY)
    ctx.lineTo(s * 0.08, axY)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(rx, axY); ctx.lineTo(rx, -s * 0.14)
    ctx.moveTo(rx - s * 0.1, -s * 0.14); ctx.lineTo(rx + s * 0.1, -s * 0.14)
    ctx.stroke()
  },

  Squash(ctx, s) {
    const lw = Math.max(1.5, s * 0.09)
    ctx.lineWidth = lw
    ctx.beginPath()
    ctx.ellipse(0, -s * 0.16, s * 0.28, s * 0.36, 0, 0, Math.PI * 2)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(-s * 0.07, s * 0.2); ctx.lineTo(-s * 0.1, s * 0.65)
    ctx.moveTo(s * 0.07, s * 0.2);  ctx.lineTo(s * 0.1, s * 0.65)
    ctx.stroke()
    ctx.lineWidth = Math.max(1, s * 0.045)
    ctx.beginPath()
    ctx.moveTo(0, -s * 0.48); ctx.lineTo(0, s * 0.16)
    ctx.moveTo(-s * 0.26, -s * 0.16); ctx.lineTo(s * 0.26, -s * 0.16)
    ctx.stroke()
    ctx.beginPath(); ctx.arc(s * 0.38, s * 0.3, s * 0.1, 0, Math.PI * 2); ctx.fill()
  },

  Badminton(ctx, s) {
    ctx.lineWidth = Math.max(1.5, s * 0.08)
    ctx.beginPath(); ctx.arc(0, s * 0.42, s * 0.13, 0, Math.PI * 2); ctx.fill()
    for (let i = 0; i < 5; i++) {
      const ang = ((i - 2) / 2) * 0.55
      ctx.beginPath()
      ctx.moveTo(0, s * 0.29)
      ctx.lineTo(Math.sin(ang) * s * 0.32, -s * 0.28)
      ctx.stroke()
    }
    ctx.beginPath()
    ctx.ellipse(0, -s * 0.28, s * 0.3, s * 0.07, 0, 0, Math.PI * 2)
    ctx.stroke()
  },

  Chess(ctx, s) {
    ctx.fillRect(-s * 0.32, s * 0.38, s * 0.64, s * 0.1)
    ctx.beginPath()
    ctx.moveTo(-s * 0.22, s * 0.38)
    ctx.lineTo(-s * 0.13, -s * 0.06)
    ctx.lineTo(s * 0.13, -s * 0.06)
    ctx.lineTo(s * 0.22, s * 0.38)
    ctx.closePath(); ctx.fill()
    ctx.beginPath(); ctx.arc(0, -s * 0.18, s * 0.13, 0, Math.PI * 2); ctx.fill()
    ctx.fillRect(-s * 0.05, -s * 0.52, s * 0.1, s * 0.36)
    ctx.fillRect(-s * 0.18, -s * 0.41, s * 0.36, s * 0.1)
  },

  Books(ctx, s) {
    ctx.lineWidth = Math.max(1.5, s * 0.09)
    ctx.beginPath(); ctx.moveTo(0, s * 0.38); ctx.lineTo(0, -s * 0.3); ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(0, -s * 0.3)
    ctx.bezierCurveTo(-s * 0.1, -s * 0.42, -s * 0.46, -s * 0.28, -s * 0.46, s * 0.38)
    ctx.lineTo(0, s * 0.38); ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(0, -s * 0.3)
    ctx.bezierCurveTo(s * 0.1, -s * 0.42, s * 0.46, -s * 0.28, s * 0.46, s * 0.38)
    ctx.lineTo(0, s * 0.38); ctx.stroke()
    ctx.lineWidth = Math.max(1, s * 0.045)
    ctx.beginPath()
    ctx.moveTo(-s * 0.35, -s * 0.04); ctx.lineTo(-s * 0.1, -s * 0.02)
    ctx.moveTo(-s * 0.35, s * 0.12);  ctx.lineTo(-s * 0.1, s * 0.14)
    ctx.stroke()
  },

  Crypto(ctx, s) {
    ctx.lineWidth = Math.max(1.5, s * 0.09)
    ctx.beginPath(); ctx.arc(0, 0, s * 0.42, 0, Math.PI * 2); ctx.stroke()
    ctx.font = `bold ${s * 0.62}px Arial, sans-serif`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText('₿', s * 0.03, s * 0.04)
  },

  Investments(ctx, s) {
    ctx.lineWidth = Math.max(1.5, s * 0.09)
    ctx.beginPath(); ctx.arc(0, 0, s * 0.42, 0, Math.PI * 2); ctx.stroke()
    ctx.font = `bold ${s * 0.62}px Arial, sans-serif`
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText('$', s * 0.03, s * 0.04)
  },
}
